<template>
    <div class="person-declaration-information">
      <z-fix-top
        keep-position
        class="fixtop"
      >
        <z-nav-bar
            class="navbar"
            left-arrow
            title="个人声明"
            style="background: #F8F8F8"
            @click-left="closePage"
        >
        </z-nav-bar>
      </z-fix-top>
      <section v-if="verify">
        <div class="desc">该用户属于依照《电子商务法》第十条规定不需要办理市场登记主体情形。经营主体相关资质信息公示如下：</div>
        <z-cell-group inset>
            <header>经营主体自我声明</header>
            <div class="descSelf">{{type[personalStatementType]}}</div>
        </z-cell-group>
        <p class="tail">注：以上资质信息由用户自行发布公示，用户承诺信息真实有效，如发现信息与实际不符，也可向平台客服反馈。</p>
      </section>
      <section v-else class="message">
        <z-loading v-if="loading" type="zz" size="60px" vertical>正在加载</z-loading>
      </section>
    </div>
</template>
<script>
import native from '@zz-common/native-adapter'
import { Loading, CellGroup, FixTop, NavBar } from '@zz-common/zz-ui';
import { getBusinessInfoByType } from '@api/resourceApi'
import { queryParams } from '@lib/utils'
const query = queryParams()
export default {
  name: 'qualityInfo',
  components: {
    'z-loading': Loading,
    'z-cell-group': CellGroup,
    'z-nav-bar': NavBar,
    'z-fix-top': FixTop
  },
  data() {
    return {
      uid: query.uid || this.$route.query.uid || '',
      verify: false,
      loading: false,
      type: {
        1: '个人销售自产农副产品，依法不需要办理市场主体登记',
        2: '个人销售家庭手工业产品登记, 依法不需要办理市场主体登记',
        3: '个人利用自己的技能从事依法无须取得许可的便民劳务活动登记, 依法不需要办理市场主体登记',
        4: '个人从事零星小额交易活动登记, 依法不需要办理市场主体登记'
      },
      personalStatementType: '1'
    }
  },
  created() {
    native.registerSlider({ action: 501, type: 3, scenetype: 2002 }, this.callback)
  },
  methods: {
    async getData({ sessionId, successToken }) {
      const params = {
        sessionId,
        successToken,
        uid: this.uid,
        businessType: 'personalStatement',
        sourceCode: 'selfmain_page',
        type: '3'
      }
      const res = await getBusinessInfoByType(params)
      const { personalStatementType } = res;
      this.personalStatementType = personalStatementType;
      this.loading = false
      this.verify = true
    },
    async callback(params) {
      const { data: { sessionId, successToken } = {}, code } = params
      if (code == -3) {
        native.close()
      } else if (code == 0) {
        this.loading = true
        setTimeout(() => {
          this.getData({ sessionId, successToken })
        }, 1500);
      }
    },
    closePage() {
      native.close();
    }
  }
}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>